import React from 'react';
import { Loader2, Settings2 } from 'lucide-react';
import { PageHeader } from '@/components/blocks/page-header';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface SettingsPageStateProps {
  variant: 'loading' | 'error' | 'missing';
  error?: string;
  onRetry: () => void;
}

export const SettingsPageState: React.FC<SettingsPageStateProps> = ({ variant, error, onRetry }) => (
  <div className="space-y-6">
    <PageHeader
      title="General Settings"

      size={36}
      showActions={false}
      showBreadcrumb={false}
      icon={<Settings2 />}
    />
    {variant === 'loading' && (
      <div className="flex items-center justify-center p-12">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Loading settings...</p>
        </div>
      </div>
    )}
    {variant === 'error' && (
      <Alert variant="destructive">
        <AlertDescription>
          <p className="font-medium mb-2">{error}</p>
          <Button onClick={onRetry} variant="outline" size="sm">
            Try Again
          </Button>
        </AlertDescription>
      </Alert>
    )}
    {variant === 'missing' && (
      <Alert variant="destructive">
        <AlertDescription>
          <p className="font-medium mb-2">Unable to load settings data</p>
          <p className="text-sm text-muted-foreground mb-3">
            Some required data is missing. This might be a data initialization issue.
          </p>
          <Button onClick={onRetry} variant="outline" size="sm">
            Reload Settings
          </Button>
        </AlertDescription>
      </Alert>
    )}
  </div>
);
